import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "../../../assets/styleadmin.css"
import api from "../../../services/api"
import {logout} from "../../../services/auth";

class HeaderAdmin extends Component {
state ={
  response:[],
  logout:false,
  useradm:[]

}

  async componentDidMount(){

    const response = await api.post("/user/details");
      this.setState({
        useradm:response.data.success,
      })


  }

  async shouldComponentUpdate(nextProps, nextState){

    if(nextState.logout==true){
      logout();
      this.props.history.push("/");

    }
    return true;
  }

  async reprocessinvoice () {
    const response = await api.get("/generated_aasasast", {d:'d'});
    if(response){
      alert("Faturas Reprocessadas");
    }
  }



  render() {
    if(this.state.response.adm==false){
      this.props.history.push("/user");
    }


    return (
      <React.Fragment>
         
<nav class="navbar navbar-expand-lg navbar-dark adminnav">

 
  <a class="navbar-brand text-black-50" href="/admin">Olga Mettig</a>

  
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#basicExampleNav"
    aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>


  <div class="collapse navbar-collapse" id="basicExampleNav">

    
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link text-black-50" href="/admin">Inicio
          <span class="sr-only">(current)</span>
        </a>
      </li>

      {this.state.useradm.admunidade==0 &&
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-black-50" id="navbarDropdownMenuLink-555" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">Cursos
        </a>
        <div class="dropdown-menu dropdown-secondary" aria-labelledby="navbarDropdownMenuLink-555">
          <a class="dropdown-item text-black" href="/admin/categoria">Categorias</a>
          <a class="dropdown-item text-black" href="/admin/cursos">Cursos</a>
        </div>
      </li>
      }
      
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-black-50" id="navbarDropdownMenuLink-555" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">Alunos
        </a>
        <div class="dropdown-menu dropdown-secondary" aria-labelledby="navbarDropdownMenuLink-555">
          <a class="dropdown-item" href="/admin/matricula/add"><strong>Adicionar Matricula</strong></a>
          <a class="dropdown-item" href="/admin/alunos">Todos os alunos</a>
          <a class="dropdown-item" href="/admin/matriculas/paid">Matriculas Pagas</a>
          <a class="dropdown-item" href="/admin/matriculas/unpaid">Matriculas Não Pagas</a>
          <a class="dropdown-item" href="/admin/datauserdata">Download Data</a>
        </div>
      </li>

      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-black-50" id="navbarDropdownMenuLink-555" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">Financeiro
        </a>
        <div class="dropdown-menu dropdown-secondary" aria-labelledby="navbarDropdownMenuLink-555">
          <a class="dropdown-item" href="/admin/faturas">Faturas</a>
        </div>
      </li>


      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-black-50" id="navbarDropdownMenuLink-555" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">Relatórios
        </a>
        <div class="dropdown-menu dropdown-secondary" aria-labelledby="navbarDropdownMenuLink-555">
          <a class="dropdown-item" href="/admin/faturas/comercial/cobranca">Cobrancas - Faturas</a>
          <a class="dropdown-item" href="/admin/relatorios">Relatorio Integral</a>
          <a class="dropdown-item" href={"/admin/relatorio/mensal/"+(parseInt(new Date().getMonth())+1)+"/"+new Date().getFullYear()}>Relatorio Mensal</a>
          <a class="dropdown-item" href={"/admin/relatorio/semestral/"+new Date().getFullYear()}>Relatorio Semestre</a>
          <a class="dropdown-item" href={"/admin/relatorio/anual/"+new Date().getFullYear()}>Relatorio Anual</a>

        </div>
    
      </li>


      
      {this.state.useradm.admunidade==0 && 

<li class="nav-item active">
        <a class="nav-link text-black-50" href="/admin/logs">Logs
          <span class="sr-only">(current)</span>
        </a>
      </li>
  }



      {this.state.useradm.admunidade==0 && 

<li class="nav-item dropdown">
<a class="nav-link dropdown-toggle text-black-50" id="navbarDropdownMenuLink-555" data-toggle="dropdown"
  aria-haspopup="true" aria-expanded="false">Unidades
</a>
<div class="dropdown-menu dropdown-secondary" aria-labelledby="navbarDropdownMenuLink-555">
  <a class="dropdown-item text-black" href="/admin/unidades">Listar Unidades</a>
  <a class="dropdown-item text-black" href="/admin/administradores">Administradores</a>
</div>
</li>  
  }


   {this.state.useradm.admunidade==0 && 
    <React.Fragment>
    <li class="nav-item">
      <a class="nav-link text-black-50" href="/admin/configuracao">Configuração</a>
    </li>

    <li class="nav-item">
    <a class="nav-link text-black-50" onClick={e => this.reprocessinvoice() } href="#">Reprocessar Fatura</a>
    </li>
    </React.Fragment>
  }

  


   
      

      
      <li class="nav-item">
        <a class="nav-link text-black-50" onClick={e => this.setState({ logout: true} )} href="#">Sair</a>
      </li>
      

    </ul>
   

    
  </div>
  

</nav>
          
      </React.Fragment>
       
    );
  }
}

export default withRouter(HeaderAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/content/header.js